// extracted by mini-css-extract-plugin
export default {"changedBy":"Author__changedBy-EcAtV"};